window.addEventListener('load', event => {
    let accordionItems = document.getElementsByClassName('accordion-item');

    for (let item of accordionItems) {
        item.addEventListener('click', () => {
            if (item.nextElementSibling.classList.contains('hidden')) {
                item.nextElementSibling.classList.remove('hidden');
                item.querySelector('.rotate-svg').classList.add('rotate-180');
            } else {
                item.nextElementSibling.classList.add('hidden');
                item.querySelector('.rotate-svg').classList.remove('rotate-180');
            }
        });
    }
});
